module.exports = __webpack_public_path__ + "static/TT1442_TW-MKM01-29b5d8e8e766b1c8d4f1293f18268f04.png";